import type * as React from 'react';

function SvgSearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M21.707 20.293L16.3116 14.8976C17.3656 13.5425 18 11.8457 18 10C18 5.5889 14.4111 2 10 2C5.5889 2 2 5.5889 2 10C2 14.4111 5.5889 18 10 18C11.8456 18 13.5425 17.3656 14.8976 16.3116L20.293 21.707C20.4883 21.9023 20.7442 22 21 22C21.2558 22 21.5117 21.9023 21.707 21.707C22.0976 21.3164 22.0976 20.6837 21.707 20.293ZM4 10C4 6.6914 6.6914 4 10 4C13.3086 4 16 6.6914 16 10C16 13.3086 13.3086 16 10 16C6.6914 16 4 13.3086 4 10Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSearch;
